export const FILTERING_PROPERTIES = [
  {
    propertyLabel: 'Username',
    key: 'Username',
    groupValuesLabel: 'Username',
    operators: [':', '!:', '=', '!='] as const,
  },
] as const;
